import script from "./orderPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./orderPrint.vue?vue&type=script&setup=true&lang=js"

import "./orderPrint.vue?vue&type=style&index=0&id=19644af0&scoped=true&lang=scss"

import exportComponent from "/Users/a1234/Documents/vue/vue3/demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19644af0"]])

export default __exports__